import {useEffect, useState} from "react";

const DEFAULT_TICK_MS = 60_000;

/** Wall-clock `now` that ticks on an interval (default 60s) for live SLA labels on kanban cards. */
export function useNow(tickMs: number = DEFAULT_TICK_MS): Date {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setNow(new Date());
        }, tickMs);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [tickMs]);

    return now;
}
